import React, { useState } from 'react';
import styled from '@emotion/styled'

const Button = styled.button`
  & rect {
    fill: ${({color}) => color} !important;
  }
`

function HamburgerAnimated({open, color}) {
  return (
    <Button color={color} aria-pressed={open} className={'hamburger'}>
        <svg aria-hidden="true" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
            <rect width="18" height="1.5" fill="red" ry="0.75" x="3" y="6.25" />
            <rect width="18" height="1.5" fill="red" ry="0.75" x="3" y="11.25" />
            <rect width="18" height="1.5" fill="red" ry="0.75" x="3" y="16.25" />
        </svg>
    </Button>
  );
}

export default HamburgerAnimated;
